// Patient-facing prescriptions — READ-ONLY (FB-authorized, Slack Jun 19 — Thomas). Renders the
// prescriptions written for the member in the cockpit, surfaced as record cards in the consumer
// portal. The fields arrive already decrypted from the API (server-side only); the member sees only
// their own rows (RLS). No write path here — this is a read of the demo_prescriptions carve-out (D5.1).
//
// This file names prescribing terms and is therefore allowlisted in scripts/check-clinical-terms.mjs,
// scoped to this ONE component (mirrors the doctor-side PrescribePanel.tsx).
import { usePrescriptionsApi } from "../lib/prescriptionsApi";
import { useAsync } from "../lib/useAsync";
import { formatDay } from "../lib/format";
import { Loading, ErrorState } from "./ui";

const PillIcon = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M10.5 20.5 3.5 13.5a4.95 4.95 0 0 1 7-7l7 7a4.95 4.95 0 0 1-7 7Z" />
    <line x1="8.5" y1="8.5" x2="15.5" y2="15.5" />
  </svg>
);

export function Prescriptions() {
  const rxApi = usePrescriptionsApi();
  const { data, loading, error } = useAsync(() => rxApi.list(), []);

  if (loading) return <Loading />;
  if (error) return <ErrorState message={error} />;

  const items = data ?? [];

  return (
    <>
      <div className="app-card-head" style={{ marginTop: 28 }}>
        <h3>Medications</h3>
      </div>
      {items.length ? (
        <div className="records-grid">
          {items.map((p) => (
            <div className="record-card" key={p.id}>
              <div className="record-card-head">
                <div className="record-card-icon">{PillIcon}</div>
                <span className={`record-tag ${p.status === "active" ? "active" : "flag"}`}>
                  {p.status === "active" ? "Active" : "Discontinued"}
                </span>
              </div>
              <h4>{p.drug}</h4>
              {p.dosage ? <div className="rx-dosage">{p.dosage}</div> : null}
              <div className="meta">Prescribed {formatDay(p.created_at)}</div>
              {p.sig ? <p>{p.sig}</p> : null}
            </div>
          ))}
        </div>
      ) : (
        <div className="pt-empty">No medications on record yet.</div>
      )}
    </>
  );
}
